import { BordOneToneIcon } from 'components/NudosComponents';
import { nudosBlue } from 'styles/styles.constants';
import { redirectToConversation } from '../../utils/mentionsColumn.utils';

import './MentionSourceInfo.scss';

interface IMentionSourceInfoProps {
  icon: React.ReactNode;
  redirectText: string;
  isExpanded: boolean;
  redirectUrl: string;
  isCustomerChatHeader?: boolean;
}

export const MentionSourceInfo = ({
  icon,
  redirectText,
  isExpanded,
  redirectUrl,
  isCustomerChatHeader = false
}: IMentionSourceInfoProps) => {
  const redirectArrowStroke = isCustomerChatHeader ? 'white' : nudosBlue;

  const handleRedirectToConversation = (event: React.MouseEvent) => {
    event.stopPropagation();
    redirectToConversation(redirectUrl);
  };

  return (
    <div className={`mentionSourceInfo ${isCustomerChatHeader ? 'customerChatHeader' : ''}`}>
      <div className="leftContent">
        {icon}
        <button className="redirectLink" onClick={handleRedirectToConversation}>
          <span className="redirectLinkText">{redirectText}</span>
          <BordOneToneIcon variant="arrowRight" stroke={redirectArrowStroke} customWidth="12px" />
        </button>
      </div>

      <div className="rightContent">
        <BordOneToneIcon variant={isExpanded ? 'arrowHeadUp' : 'arrowHeadDown'} stroke="white" customWidth="12px" />
      </div>
    </div>
  );
};
